import { or } from 'ramda';
import React, { FC, useState } from 'react';

import Skeleton from '@ui/atoms/Skeleton';

import BookingUnavailable from '@ui/organisms/BookingUnavailable/BookingUnavailable.component';

interface IFrameContainerProps {
	url: string;
	iFrameStyle?: any;
	loading?: boolean;
}

const IFrameContainer: FC<IFrameContainerProps> = ({ iFrameStyle, url, loading }) => {
	const [loadingData, setLoadingData] = useState<boolean>(true);

	return (
		<BookingUnavailable>
			{or(loadingData, loading) && <Skeleton fullHeight fullWidth structure="single" />}
			<iframe
				style={loadingData || loading ? { display: 'none' } : iFrameStyle}
				onLoad={() => setLoadingData(false)}
				title="iFrame"
				src={url}
			/>
		</BookingUnavailable>
	);
};

export default IFrameContainer;
